import { render, staticRenderFns } from "./BaseIconStarWithValue.vue?vue&type=template&id=7b16ea14&scoped=true&lang=pug"
import script from "./BaseIconStarWithValue.vue?vue&type=script&lang=js"
export * from "./BaseIconStarWithValue.vue?vue&type=script&lang=js"
import style0 from "./BaseIconStarWithValue.vue?vue&type=style&index=0&id=7b16ea14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b16ea14",
  null
  
)

export default component.exports